import { CssSelectors } from '../../../styles/styles';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	logo: {
		height: 24,
	},
	logoWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginTop: 20,
		flexDirection: 'column',
		width: 130,
	},
	button: {
		marginTop: 24,
		padding: '10px 60px',
		width: '80%',
	},
	center: {
		display: 'flex',
		justifyContent: 'center',
	},
	container: {
		background: THEME.colors.background.light,
		boxSizing: 'border-box',
		// The parent Page is a fixed-height flex column, and flex items default to shrink-to-fit, which
		// squeezed this box to the viewport while tall preview content spilled past the painted background.
		flexShrink: 0,
		minHeight: '100%',
		padding: `0 ${THEME.spacing.md}px ${THEME.spacing.md}px`,
		width: '100%',
	},
	customButton: {
		':hover': {
			background: 'none',
			textDecoration: 'underline',
		},
		background: 'none',
		border: 'none',
		boxShadow: 'none',
		display: 'inline',
		outlone: 'none',
		padding: '0 0 0 5px',
	},
	inProgressContainer: {
		display: 'flex',
		flexDirection: 'column',
		...CssSelectors.allChildren(
			{
				margin: 0,
				paddingTop: 5,
			},
			'p'
		),
	},
	inProgressIconContainer: {
		background: '#f9f9f9',
		borderRadius: '50%',
		height: 150,
		marginBottom: 20,
		position: 'relative',
		width: 150,
	},
	signInContainer: {
		minHeight: 0,
	},
});
